import React, { Component } from 'react'
import {connect} from 'react-redux'
import {modalToggleReset,modalToggle} from '../../../redux/actions/general'
import { MuiThemeProvider, createMuiTheme,withStyles, } from '@material-ui/core/styles'
import {Button } from '@material-ui/core'
import Close3 from 'assets/icon/close3.svg'
const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main:'#00ACC1',
        },
        secondary: {
            main:'#ffc466',
            contrastText: '#FFFFFF',
        }
    } 
})
class alert extends Component {
    
    renderFooter=()=>{
        const {modal_component,modal_data,success_msg}=this.props.general
        
        // switch (modal_component) {
        //     case 'proyek':
        //         return(
        //             <Button onClick={()=>this.props.modalToggleReset()}   size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded '>Tutup</Button>
        //         )     
        //     case 'client':
        //         return(
        //             <Button onClick={()=>this.props.modalToggleReset()}   size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded '>Tutup</Button>
        //         )     
        //     case 'peserta':
        //         return(
        //             <Button onClick={()=>this.props.modalToggleReset()}   size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded '>Lihat detail peserta</Button>
        //         )     
        //     case 'delete_peserta':
        //         return(
        //             <Button onClick={()=>this.props.modalToggleReset()}   size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded '>Tutup</Button>
        //         )     
        //     case 'kominfo':
        //         return(
        //             <Button onClick={()=>this.props.sendReportKominfo(modal_data.slug,modal_data.name)}   size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded '>Kirim ulang</Button>
        //         )     
            
            
        //     default:
        //         break;
        // }
    }
    render() {
        const {modal_data,modal_title,modal_action}=this.props.general
        return (
            <div className='alert-container'>
                
                <img src={Close3} style={{width:'40%'}}/>
                <br/>
                <h4>{modal_title}</h4>
                <div dangerouslySetInnerHTML={{ __html: modal_data.msg }}></div>
                {/* <MuiThemeProvider theme={themeButton}>
                    {this.renderFooter()}
                </MuiThemeProvider> */}
            </div>
        )
    }
}
const mapStateToProps=(state)=>({
    general:state.general
})
const mapDispatchToProps={
    modalToggleReset,
    modalToggle,
}
export default connect(mapStateToProps,mapDispatchToProps)(alert)